import React, { useRef } from 'react';

import Slider from 'react-slick';

import styles from './listingDetailCarousel.module.less';

const SLIDER_SETTINGS = {
  autoplaySpeed: 1500,
  nextArrow: <></>,
  prevArrow: <></>,
};

type ListingDetailCarouselProps = {
  items: JSX.Element[];
};

export const ListingDetailCarousel = ({ items }: ListingDetailCarouselProps): JSX.Element => {
  const sliderRef = useRef<Slider | null>(null);

  return (
    <div
      className={styles.carousel}
      onMouseEnter={() => sliderRef.current?.slickPlay()}
      onMouseLeave={() => {
        sliderRef.current?.slickPause();
        sliderRef.current?.slickGoTo(0);
      }}
    >
      <Slider {...SLIDER_SETTINGS} ref={sliderRef}>
        {items}
      </Slider>
    </div>
  );
};
